<!-- 查询商家券模板接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"queryType":0,"traderCode":"NWA2H9ZFJ2Q3","page":1,"pageSize":10,"couponCodeList":["GC593B8RKXTU","GC592WARZAEC"]},
            responseCode: {
                "data": {
                    "totalCount":"10",
                    "page":"1",
                    "couponList":[{
                "couponTemplate": {
                    "balanceType": 1,
                    "code": "GC593B8RKXTU",
                    "couponType": 1,
                    "createTime": "20170824114245",
                    "faceValue": "50",
                    "name": "test0824001",
                    "originalPrice": 60,
                    "realPrice": 50,
                    "remark": "false",
                    "useRuleFrom": 0,
                    "useRuleTo": 1000,
                    "validFrom": "20160906181930",
                    "validMinute": 1440,
                    "validTo": "20170906181930"
                },
                "grantedCount": 0,
                "sellBillId": "2544",
                "totalCount": 50,
                "usedCount": 0
            },
            {
                "couponTemplate": {
                    "balanceType": 0,
                    "code": "GC592WARZAEC",
                    "couponType": 1,
                    "createTime": "20170824113719",
                    "faceValue": "50",
                    "name": "test0824",
                    "originalPrice": 60,
                    "realPrice": 50,
                    "remark": "false",
                    "useRuleFrom": 0,
                    "useRuleTo": 1000,
                    "validFrom": "20160906181930",
                    "validMinute": 1440,
                    "validTo": "20170906181930"
                },
                "grantedCount": 1,
                "sellBillId": "2543",
                "totalCount": 50,
                "usedCount": 0
            }]
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询电子券信息",
                t_url: this.commonUrls.test+"queryCoupon",
                p_url: this.commonUrls.prod+"queryCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'traderCode', info2: '是', info3: 'String', info4: '授权商对应的商家代号' },
                        { info1: 'queryType', info2: '是', info3: 'Integer', info4: '搜索范围 :值0 查询指定的券;值1 查询所有券;值2 查询可发放的券;' },
                        { info1: 'couponCodeList', info2: '否', info3: 'String', info4: '券模版代号列表, 要查询指定的券需要传入此参数' },
                        { info1: 'page', info2: '是', info3: 'Integer', info4: '分页查询, 当前页码, 从1开始, 默认值1' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页显示记录数, 默认为10, 最大值不能超过500' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'totalCount', info2: '是', info3: 'Integer', info4: '总记录数' },
                        { info1: 'page', info2: '是', info3: 'Integer', info4: '分页查询, 当前页码, 从1开始, 默认值1' },
                        { info1: 'couponList', info2: '是', info3: 'JSONArray', info4: '券信息列表' }
                        ]
                },{
                    titleName: 'couponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'sellBillId', info2: '是', info3: 'Integer', info4: '销售账单ID, 发券时需要用的重要参数' },
                        { info1: 'totalCount', info2: '是', info3: 'Integer', info4: '券总数量' },
                        { info1: 'grantedCount', info2: '是', info3: 'Integer', info4: '已发放数量' },
                        { info1: 'usedCount', info2: '是', info3: 'Integer', info4: '使用数量' },
                        { info1: 'couponTemplate', info2: '是', info3: 'JSONObject', info4: '券模板' }
                        ]
                },{
                    titleName: 'couponTemplate',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'name', info2: '是', info3: 'String', info4: '券名称' },
                        { info1: 'code', info2: '是', info3: 'String', info4: '券编码，唯一识别' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '券可发放的开始时间，yyyyMMddHHmmss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '券可发放的结束时间，yyyyMMddHHmmss' },
                        { info1: 'validMinute', info2: '是', info3: 'Integer', info4: '发券后券的有效分钟数' },
                        { info1: 'balanceType', info2: '是', info3: 'Integer', info4: '结算类型，0:销售结算,1:发放结算,2:使用结算\t' },
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '券类型，0：免费券，车费0元结算 1：金额扣减券，车费减免固定金额结算 2：金额折扣券，车费折扣减免结算 3：金额固定值券，车费按券的固定值结算 4：时间券，时间减免后再按车费结算 5:不同计价券,按不同计价规则车费结算' },
                        { info1: 'faceValue', info2: '是', info3: 'String', info4: '面值，免费券:默认0，金额扣减券:为大于0的正数且保留2位小数，金额折扣券:为0-1且保留2位小数，金额固定券:为大于0的正数且保留2位小数，时间券:为大于0的整数，说明:金额相关的券都以元为单位，时间券以分为单位' },
                        { info1: 'originalPrice', info2: '是', info3: 'Decimal', info4: '原价，不是出售的券填0.00' },
                        { info1: 'realPrice', info2: '是', info3: 'Decimal', info4: '折扣价，不是出售的券填0.00' },
                        { info1: 'useRuleFrom', info2: '是', info3: 'Decimal', info4: '使用规则金额最小值' },
                        { info1: 'useRuleTo', info2: '是', info3: 'Decimal', info4: '使用规则金额最大值' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'createTime', info2: '是', info3: 'String', info4: '券创建时间，yyyyMMddHHmmss' },
                        { info1: 'isCover', info2: '否', info3: 'Integer', info4: '是否叠加使用(0:否,1:是)' },
                        { info1: 'maxCover', info2: '否', info3: 'Integer', info4: '最大叠加数' },
                        { info1: 'datePrivilegeType', info2: '否', info3: 'Integer', info4: '区分日期的选择形式，0=未选择，1=按周，2=按月，3=整月' },
                        { info1: 'privilegeDate', info2: '否', info3: 'String', info4: '有效期' },

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/queryCoupon.vue